import React from 'react';
import * as baseUI from '#packages/baseUI';
import constants from '#packages/constants';
import type { PluginScope } from '../plugin/types';
import { reportBi } from '../bi';

const translations = {
  title:
    'To move an element to a different container, duplicate it and hide the current one. Mobile will no longer sync with desktop.',
};

const getTargetLayout = (scope: PluginScope) => {
  const { editorAPI, selectedComp } = scope;
  const { site } = editorAPI;

  const layoutGet = editorAPI.components.layout.getRelativeToScreen_rect;
  const selectedCompsLayout = layoutGet(selectedComp);

  return {
    height: 0,
    width: 0,
    top: selectedCompsLayout.height + selectedCompsLayout.y + 50,
    left: site.getSiteX() + 550,
  };
};

const createShowNotificationHandler = () => {
  let notificationOpened = false;

  return (scope: PluginScope) => {
    if (notificationOpened) {
      return;
    }

    const { editorAPI } = scope;

    const onClose = () => {
      editorAPI.hideFloatingBubble();

      notificationOpened = false;
    };

    const targetLayout = getTargetLayout(scope);

    editorAPI.floatingBubble.show(
      React.createElement(baseUI.popoverTemplates.quickTip, {
        text: translations.title,
        // todo - add translation keys

        symbol: 'idea-bulb',
        closeAction: onClose,
      }),
      targetLayout,
      {
        noArrow: true,
        shake: false,
        behindPopUps: true,
        alignment: 'bottom',
        closeTriggers: [constants.UI.TOOLTIP.TRIGGERS.TIMER],
        closeDelay: 10000,
        hideMethod: onClose,
      },
      {
        countDisplayTimesOptions: {
          countBy: 'site',
          maxNum: 3,
          uniqueBubbleId: 'quickTipForNoReparenting5',
        },
      },
    );

    reportBi.notificationAppear(translations.title);

    notificationOpened = true;
  };
};

export const showNotificationOnCollision = createShowNotificationHandler();
